import React, { useState } from 'react';
import { Alert, Input, message, Modal, Table, Typography } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { fetcher } from '../../../../extras/fetcher';

export interface PalletForDeliveryMove {
  id: number;
  kod: string;
  kod_klienta: string;
  SSCC: string;
  udc: number;
}

interface Props {
  open: boolean;
  pallets: PalletForDeliveryMove[];
  sourceDeliveryNr?: string;
  handleSetModalOpened: (opened: boolean) => void;
  handleGetData: () => void | Promise<void>;
}

export const ModalMovePalletsBetweenDeliveries = (props: Props) => {
  const [targetDeliveryNr, setTargetDeliveryNr] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [messageApi, contextHolder] = message.useMessage();

  const columns: ColumnsType<PalletForDeliveryMove> = [
    {
      title: 'Kod',
      dataIndex: 'kod',
      width: 140,
    },
    {
      title: 'Kod Klienta',
      dataIndex: 'kod_klienta',
      width: 140,
    },
    {
      title: 'SSCC',
      dataIndex: 'SSCC',
      width: 230,
    },
    {
      title: 'UDC',
      dataIndex: 'udc',
      width: 120,
    },
  ];

  const closeModal = () => {
    setTargetDeliveryNr('');
    props.handleSetModalOpened(false);
  };

  const handleMove = async () => {
    if (!/^[3-4][0-9]{9}$/.test(targetDeliveryNr)) {
      messageApi.error('Podany numer delivery jest nieprawidłowy!');
      return;
    }

    setLoading(true);

    try {
      const response = await fetcher(
        'ikea/pallet/move-between-deliveries',
        'PATCH',
        {
          palletIds: props.pallets.map((pallet) => pallet.id),
          targetDeliveryNr,
        },
      );

      if (response.status === 401 || response.status === 403) {
        messageApi.error('Nie posiadasz wymaganych uprawnień!');
        return;
      }

      if (!response.result?.success) {
        const errorMessage = Array.isArray(response.result?.message)
          ? response.result.message.join(' ')
          : response.result?.error ?? response.result?.message;

        messageApi.error(errorMessage ?? 'Nie udało się przenieść palet.');
        return;
      }

      messageApi.success(
        `Przeniesiono ${response.result.moved} palet do delivery ${targetDeliveryNr}.`,
      );
      closeModal();
      await props.handleGetData();
    } catch (error) {
      messageApi.error('Nie udało się połączyć z serwerem.');
    } finally {
      setLoading(false);
    }
  };

  return <>
    {contextHolder}
    <Modal
      bodyStyle={{padding: 10}}
      width={760}
      title="Przenoszenie palet do innej delivery"
      open={props.open}
      okText="Przenieś"
      cancelText="Anuluj"
      onOk={handleMove}
      onCancel={closeModal}
      confirmLoading={loading}
      okButtonProps={{disabled: props.pallets.length === 0}}
      destroyOnClose
    >
      <Alert
        type="info"
        showIcon
        message={`Delivery źródłowa: ${props.sourceDeliveryNr ?? 'różne delivery'}`}
        description={`Liczba wybranych palet: ${props.pallets.length}`}
        style={{marginBottom: 16}}
      />

      <Typography.Text strong>Docelowy numer delivery</Typography.Text>
      <br/>
      <Input
        value={targetDeliveryNr}
        onChange={(event) => setTargetDeliveryNr(
          event.target.value.replace(/\D/g, '').slice(0, 10),
        )}
        onPressEnter={handleMove}
        placeholder="Np. 3103112272"
        maxLength={10}
        style={{width: 240, margin: '8px 0 16px'}}
      />

      <Table
        rowKey="id"
        columns={columns}
        dataSource={props.pallets}
        pagination={false}
        scroll={{y: 260}}
        size="small"
        bordered
      />
    </Modal>
  </>;
};
